<template lang="pug">
div
  v-layout.input-row(v-if='productTypeInitial === "misc"')
    label Soort product
    v-select(
      v-model='productTypeData',
      :items='productTypeItems',
      placeholder='Kies een soort product',
      solo
      )

  v-layout.input-row(v-if='pvInputAllowed || productTypeInitial === "misc"')
    label(v-if='isBusinessLease') Leasebedrag (bruto)
    label(v-else) Leasebedrag
      //- v-tooltip(top)
        v-icon(color='primary', slot='activator') fa fa-info-circle
        span Dit is het eventuele aanbetaling of geschatte inruilwaarde van je inruilauto. Deze wordt in vermindering gebracht op je maandelijkse termijnbedrag.
    euro-field(
      v-model.number='data.pv',
      :error-messages='pvValidationErrors',
      @change='$v.data.pv.$touch',
      @blur='$v.data.pv.$touch'
      )

    //- euro-field(
      v-model.number='data.vat',
      label='BTW',
      disabled,
      v-if='isBusinessLease',
      solo
      )

  v-layout.input-row(v-if='productType !== "misc"')
    label Aanbetaling
      v-tooltip(top)
        v-icon(color='primary', slot='activator') fa fa-info-circle
        span Dit is het eventuele aanbetaling of geschatte inruilwaarde van je inruilauto. <br> Deze wordt in vermindering gebracht op je maandelijkse termijnbedrag.
    euro-field(
      v-model.number='data.deposit',
      :error-messages='depositValidationErrors',
      @change='$v.data.deposit.$touch()',
      @blur='$v.data.deposit.$touch()'
      )

  v-layout.input-row
    label Gewenste looptijd
      v-tooltip(top)
        v-icon(color='primary', slot='activator') fa fa-info-circle
        span Selecteer hier je gewenste looptijd. <br> Hoe korter je looptijd des te hoger het maandbedrag zal zijn.
    v-select(
      v-model='data.nper',
      :items='nperItems',
      :error-messages='nperValidationErrors',
      @change='$v.data.nper.$touch()',
      @blur='$v.data.nper.$touch()',
      solo,
      prepend-inner-icon='fas fa-calendar-alt'
      )

  v-layout.input-row(v-if='productType !== "misc"')
    label Slottermijn
      v-tooltip(top)
        v-icon(color='primary', slot='activator') fa fa-info-circle
        span Indien je kiest voor een slottermijn, dan zijn je maandbedragen lager maar je betaald wel rente over het gehele lease bedrag. <br>Dit bedrag wordt in de laaste maand in rekening gebracht.
    euro-field(
      v-model.number='data.fv',
      :error-messages='fvValidationErrors',
      @change='$v.data.fv.$touch()',
      @blur='$v.data.fv.$touch()'
      )

  v-layout.input-row(v-if='showRateField')
    label Rentepercentage
    text-field(
      v-model.number='data.ratePercentage'
      )

  v-layout.pmt.input-row.mt-4.flex-column-phone.flex-justify-center-phone(align-center)
    label
      h1 Maandbedrag
    transition(name='fade', mode='out-in')
      h1.primary--text(v-if='calculated && lastCalculatedPmt', key='h1pmt') {{ lastCalculatedPmt | currency }}

</template>

<script>
import { nperItems } from './helpers/constants'
// import { required, minValue } from 'vuelidate/lib/validators'
import required from 'vuelidate/src/validators/required'
import minValue from 'vuelidate/src/validators/minValue'
import { productTypeItems } from 'dealerfinanceservices-shared/src/helpers/constants'

export default {
  props: {
    value: Object,
    isBusinessLease: {
      type: Boolean,
      default: true
    },
    pvInputAllowed: {
      type: Boolean,
      default: false
    },
    calculateFunction: Function,
    showRateField: {
      type: Boolean,
      default: false
    },
    productType: String
  },

  data: function () {
    return {
      data: this.value,
      productTypeData: this.productType,
      productTypeInitial: this.productType,
      lastCalculatedPmt: null,

      loading: false,
      recalculateTimer: null,
      ignoreRecalculate: false,
      calculated: false,
      productTypeItems,

      nperItems
    }
  },

  computed: {
    isExampleForm () {
      return this.$store.state.payload && this.$store.state.payload.domain === 'example.com'
    },

    pvValidationErrors () {
      const errors = []
      if (!this.$v.data.pv.$dirty) return errors
      !this.$v.data.pv.required && errors.push('Dit veld is verplicht')
      !this.$v.data.pv.minValue && errors.push('Een lease aanvragen zonder geldig bedrag is niet mogelijk')
      !this.$v.data.pv.biggerThanDepositAndFv && errors.push('Leasebedrag moet hoger zijn dan de aanbetaling en slottermijn samen')
      return errors
    },

    depositValidationErrors () {
      const errors = []
      if (!this.$v.data.deposit.$dirty) return errors
      !this.$v.data.deposit.required && errors.push('Dit veld is verplicht')
      !this.$v.data.deposit.smallerThanPv && errors.push('Aanbetaling en slottermijn mogen samen niet hoger zijn dan het leasebedrag')
      return errors
    },

    nperValidationErrors () {
      const errors = []
      if (!this.$v.data.nper.$dirty) return errors
      !this.$v.data.nper.required && errors.push('Dit veld is verplicht')
      return errors
    },

    fvValidationErrors () {
      const errors = []
      if (!this.$v.data.fv.$dirty) return errors
      !this.$v.data.fv.required && errors.push('Dit veld is verplicht')
      !this.$v.data.fv.smallerThanPv && errors.push('Aanbetaling en slottermijn mogen samen niet hoger zijn dan het leasebedrag')
      return errors
    }
  },

  methods: {
    triggerRecalculate () {
      clearTimeout(this.recalculateTimer)

      this.lastCalculatedPmt = null

      if (this.$v.$invalid) {
        this.calculated = true
      }

      if (this.ignoreRecalculate || this.$v.$invalid) return

      this.calculated = false

      this.recalculateTimer = setTimeout(() => {
        this.recalculate()
      }, 1000)
    },

    async recalculate () {
      if (this.data.pv === undefined || this.data.fv === undefined || this.data.nper === undefined || this.data.deposit === undefined) return
      if (isNaN(this.data.pv) || isNaN(this.data.fv) || isNaN(this.data.nper) || isNaN(this.data.deposit)) return
      if (this.data.pv <= 0) return
      if (this.$v.$invalid) return

      if (this.data.pmt) {
        this.lastCalculatedPmt = this.data.pmt
        this.calculated = true
        delete this.data.pmt

        return
      }

      this.ignoreRecalculate = true
      this.loading = true

      try {
        // Special case for preview in portal
        if (this.isExampleForm) {
          this.lastCalculatedPmt = 10000
        } else {
          const calcResult = await this.calculateFunction({
            pv: this.data.pv,
            fv: this.data.fv,
            nper: this.data.nper,
            deposit: this.data.deposit
          })

          if (calcResult === false) throw new Error('calculate function aborted')

          if (!calcResult.pv || !calcResult.nper) throw new Error('calculate function is not returning the correct values')

          this.data.pv = calcResult.pv
          this.data.fv = calcResult.fv
          this.data.nper = calcResult.nper
          this.data.deposit = calcResult.deposit

          this.lastCalculatedPmt = calcResult.pmt
        }

        this.calculated = true
      } catch (error) {
        console.error(error)

        // alert('Er is iets fout gegaan. Probeer het opnieuw.')
      }

      this.loading = false

      setTimeout(() => { // because this method ends before the watchers are triggered
        this.ignoreRecalculate = false
      }, 200)
    }
  },

  validations: {
    data: {
      pv: {
        required,
        minValue: minValue(1),
        biggerThanDepositAndFv: (pv, data) => pv > data.deposit + data.fv
      },

      deposit: {
        required,
        smallerThanPv: (deposit, data) => deposit + data.fv < data.pv
      },

      nper: {
        required
      },

      fv: {
        required,
        smallerThanPv: (fv, data) => data.deposit + fv < data.pv
      }
    }
  },

  watch: {
    '$v.$invalid': {
      handler: function (v) {
        this.$emit('setValid', {
          modelName: 'leaseModel',
          valid: !v
        })
      },
      immediate: true
    },

    value (v) {
      this.data = v

      if (!this.data.fv) this.data.fv = 0
      if (!this.data.deposit) this.data.deposit = 0
    },

    data: {
      handler: function (v) {
        this.$emit('input', v)

        this.triggerRecalculate()
      },
      immediate: true,
      deep: true
    },

    productTypeData (v) {
      this.$emit('setProductType', v)

      this.data.fv = 0
      this.data.deposit = 0

      this.$v.$reset()
    },

    productType (v) {
      this.productTypeData = v
    },

    lastCalculatedPmt: {
      handler: function (v) {
        this.$emit('updatedPmt', v)
      },
      immediate: true
    },

    loading (v) {
      this.$emit('setLoading', v)
    },

    calculated (v) {
      this.$emit('setCalculated', v)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/responsive.scss";

.input-row {
  align-items: baseline;
  height: 65px;

  @include phone {
    margin-top: 40px;
    flex-direction: column;
    align-items: flex-start;

    &:first-of-type {
      margin-top: 0;
    }
  }

  label {
    width: 240px;

    @include phone {
      width: auto;
      margin-bottom: 10px;
    }

    i {
      margin-left: 5px;
      font-size: 18px;
    }
  }

  .v-input {
    margin-bottom: -20px !important;
    flex-grow: 1;

    @include phone {
      width: 100%;
    }
  }
}

.pmt {
  height: auto;
  align-items: center;

  label h1 {
    @include phone {
      text-align: center;
    }
  }
}
</style>
